import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { Separator } from '../ui/separator';
import { Globe, FileText, BarChart3, ExternalLink } from 'lucide-react';
import { generateSitemap, getSitemapStats } from '../../lib/sitemap-generator';
import { useToast } from '../../lib/use-toast';

const SitemapManager = () => {
  const [sitemapPreview, setSitemapPreview] = useState('');
  const [isGenerating, setIsGenerating] = useState(false);
  const { toast } = useToast();

  // Générer un aperçu du sitemap
  const handleGeneratePreview = () => {
    setIsGenerating(true);
    try {
      const sitemap = generateSitemap();
      setSitemapPreview(sitemap);
      toast({
        title: "Sitemap généré",
        description: "L'aperçu du sitemap a été généré avec succès.",
        variant: "success",
      });
    } catch (error) {
      console.error('Erreur lors de la génération du sitemap:', error);
      toast({
        title: "Erreur",
        description: "Impossible de générer le sitemap.",
        variant: "destructive",
      });
    } finally {
      setIsGenerating(false);
    }
  };



  const stats = getSitemapStats();

  return (
    <div className="space-y-4">
      {/* En-tête simplifié pour l'intégration */}
      <div>
        <h3 className="text-lg font-semibold mb-2">Sitemap SEO</h3>
        <p className="text-sm text-muted-foreground">
          Sitemap généré automatiquement à chaque déploiement. Statistiques et aperçu disponibles ci-dessous.
        </p>
      </div>

      {/* Statistiques */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <BarChart3 className="h-5 w-5" />
            Statistiques du Sitemap
          </CardTitle>
          <CardDescription>
            Aperçu des pages incluses dans le sitemap
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="text-center">
              <div className="text-2xl font-bold text-primary">{stats.totalPages}</div>
              <div className="text-sm text-muted-foreground">Total pages</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-blue-600">{stats.staticPages}</div>
              <div className="text-sm text-muted-foreground">Pages statiques</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-green-600">{stats.freeCoursesCount}</div>
              <div className="text-sm text-muted-foreground">Cours gratuits</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-orange-600">{stats.paidCoursesCount}</div>
              <div className="text-sm text-muted-foreground">Cours premium</div>
            </div>
          </div>
        </CardContent>
      </Card>

              {/* Actions simplifiées */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Globe className="h-5 w-5" />
              Outils SEO
            </CardTitle>
            <CardDescription>
              Sitemap déployé automatiquement - Outils de développement et monitoring
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="space-y-3">
              <div className="flex items-center justify-between p-3 bg-green-50 dark:bg-green-950/20 rounded-lg border border-green-200 dark:border-green-800">
                <div>
                  <h4 className="font-medium text-green-800 dark:text-green-200">Sitemap en ligne</h4>
                  <p className="text-sm text-green-600 dark:text-green-400">
                    Accessible à https://monpremierjeu.fr/sitemap.xml
                  </p>
                </div>
                <Button 
                  onClick={() => window.open('https://monpremierjeu.fr/sitemap.xml', '_blank')}
                  variant="outline"
                  size="sm"
                >
                  <ExternalLink className="h-4 w-4 mr-2" />
                  Voir en ligne
                </Button>
              </div>
              
              <div className="flex flex-wrap gap-2">
                <Button 
                  onClick={handleGeneratePreview}
                  disabled={isGenerating}
                  variant="outline"
                  size="sm"
                >
                  <FileText className="h-4 w-4 mr-2" />
                  {isGenerating ? "Génération..." : "Aperçu local"}
                </Button>
                
                <Button 
                  onClick={() => window.open('https://search.google.com/search-console', '_blank')}
                  variant="outline"
                  size="sm"
                >
                  <ExternalLink className="h-4 w-4 mr-2" />
                  Search Console
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>

     
    </div>
  );
};

export default SitemapManager;
